export const fieldNames = [
  "firstname",
  "lastname",
  "middlename",
  "nationality",
  "title",
  "birth",
  "document.code",
  "document.expiration",
  "differentData",
  "files[]",
] as const

export const DATE_FORMAT = "YYYY-MM-DD"

export const EDITING_STEPS = {
  SELECTION: "selection",
  SUMMARY: "summary",
  SUMMARY_OFFER: "summaryOffer",
  LATE: "late",
  FORM: "form",
  THANK_YOU: "thankyou",
  ERROR: "error",
} as const
